import * as firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/analytics'
import 'firebase/storage'

/*
const firebaseConfig = {
  apiKey: 'AIzaSyDPdIQskRjpEgmcEwz9pXYJslaGlKOjZ2Y',
  projectId: 'cz-test-7980b',
  appId: '1:223525314634:web:2b8184ace00211eac386b3',
  storageBucket: 'cz-test-7980b.appspot.com',
  measurementId: 'G-H60ZB9G2C7'
}
*/

const firebaseConfig = {
  apiKey: 'AIzaSyCxJ7rD-ah_hIIW2t6Qm9x8IL4C0hAhJKc',
  projectId: 'clickzip-de',
  storageBucket: 'clickzip-de.appspot.com',
  appId: '1:19160460926:web:1d3a51b60746a5fb6a322f',
  measurementId: 'G-D962K1Q55H'
}

// Get a Firestore instance
firebase.initializeApp(firebaseConfig)
const fb = firebase
const db = firebase.firestore()
const auth = firebase.auth()
// const storage = firebase.storage()
const analytics = firebase.analytics()
let storage = null
if (typeof firebase.storage === 'function') {
  storage = firebase.storage()
}
const timestamp = firebase.firestore.FieldValue.serverTimestamp()

export { fb, db, auth, storage, analytics, timestamp }
